import * as Context from "effect/Context";
export const FlushSync = Context.GenericTag("FlushSync");
export class AppState extends Context.Tag("AppState")() {
}
export class SyncLock extends Context.Tag("SyncLock")() {
}
export class SyncLockAlreadySyncingError {
    constructor() {
        this._tag = "SyncLockAlreadySyncingError";
    }
}
